import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-304014c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modalConfirmDeleteAlmunus",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title text-center fw-bold w-100" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = { class: "modal-body content mx-0 p-0" }
const _hoisted_8 = { class: "px-4" }
const _hoisted_9 = { class: "fw-bold py-4" }
const _hoisted_10 = { class: "bg-light py-3 ps-3 pe-2 mb-4" }
const _hoisted_11 = { class: "list-id" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode()
const _hoisted_13 = { class: "me-2" }
const _hoisted_14 = { class: "row mx-0 px-0 d-flex justify-content-center flex-sm-row flex-column-reverse mb-4" }
const _hoisted_15 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_16 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4 mb-lg-0" }

import { onMounted, PropType, ref } from 'vue'
import { useRoute } from 'vue-router'
import { Modal } from 'bootstrap'
import { numberWithCommas } from '@/constants/common.ts'
import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import communityAlumnusServices from '@/services/community-alumnus.services'
import { CONVERSATIONS_STORE } from '@/store/constants'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Array as PropType<Array<{ management_no: string; family_name: string; given_name: string; display_name: string }>>,
  reload: Function as PropType<() => void | undefined>,
  getListUserFailed: Function as PropType<any>,
},
  setup(__props) {

const props = __props

const route = useRoute()
const store = useStore()
const modalSuccess = ref()
const modalConfirm = ref()



const loadingConfirm = ref(false)
const onSubmit = async (): Promise<void> => {
  const { data, reload, getListUserFailed } = props

  loadingConfirm.value = true
  try {
    const response = await communityAlumnusServices.deleteAlmuniApi({
      id: route.params?.id,
      payload: {
        users_management_no: data?.map((item: any) => item.management_no),
      },
    })

    if (response.status === 200) {
      await getListUserFailed(response.data.data.error_users_management_no)
      loadingConfirm.value = false
      store.dispatch(CONVERSATIONS_STORE.ACTIONS.CHECK_ALL_MANAGEMENT_NO, { typeData: 'alumni', type: 'unCheckAll', data: [] })
      modalConfirm.value?.hide()
      modalSuccess.value?.show()
      reload()
      return
    }
    loadingConfirm.value = false
    modalConfirm.value?.hide()
  } catch (error) {
    loadingConfirm.value = false
    modalConfirm.value?.hide()
    console.log(error)
  }
}

const statusMap: Record<string, string> = {
  leave: translate('SO10user30'),
  available: translate('OE12pause'),
}

const getItemDisplay = (item: any): string => {
  return `${item.family_name} ${item.given_name} ${statusMap[item.status] || ''} (${item.display_name})`
}

onMounted(() => {
  modalSuccess.value = new Modal(document.getElementById('modalSuccessAlmunus'))
})
onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('modalConfirmDeleteAlmunus'))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('OE10titleModal')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("form", {
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(numberWithCommas)(__props.data?.length)) + _toDisplayString(_unref(translate)('selectingUserItems')), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("ul", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "mb-2 d-flex align-items-center",
                      key: index
                    }, [
                      _createVNode(UserAliasIcon, { userType: 2 }),
                      _hoisted_12,
                      _createElementVNode("span", _hoisted_13, _toDisplayString(item?.management_no), 1),
                      _createElementVNode("span", null, _toDisplayString(getItemDisplay(item)), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(Button, {
                    title: _unref(translate)('cancel'),
                    type: 'secondary',
                    "data-bs-dismiss": "modal"
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(Button, {
                    title: _unref(translate)('OE10withdrawnButton'),
                    type: 'secondary',
                    onClick: onSubmit,
                    disabled: loadingConfirm.value,
                    loading: loadingConfirm.value
                  }, null, 8, ["title", "disabled", "loading"])
                ])
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}
}

})